import React from 'react';
import { Dismiss20Regular } from '@fluentui/react-icons';
import styles from '../css/vdr.module.css';
const DeleteConfirmModal = ({ open, onClose, onConfirm, count = 0, linked = { informationRequests: 0, observations: 0 }, loading }) => {
    const [step, setStep] = React.useState(1);

    React.useEffect(() => {
        if (open) setStep(1);
    }, [open]);

    if (!open) return null;

    return (
        <div className={styles.overlay} role="dialog" aria-modal="true">
            <div className={styles.modal}>
                <div className={styles.modalHeader}>
                    <h2 className={styles.modalTitle}>{step === 1 ? `Delete ${count} file${count === 1 ? '' : 's'}?` : 'Confirm deletion'}</h2>
                    <button type="button" className={styles.iconBtn} onClick={onClose} aria-label="Close">
                        <Dismiss20Regular />
                    </button>
                </div>
                <div className={styles.modalBody}>
                    {step === 1 ? (
                        <>
                            <p className={styles.deleteWarnText}>
                                {linked.informationRequests || linked.observations
                                    ? <>
                                        The selected files are linked to <strong>{linked.informationRequests} Information Requests</strong> and{' '}
                                        <strong>{linked.observations} Observations</strong>. Those records will lose their file references.
                                    </>
                                    : <>Delete {count} selected file{count === 1 ? '' : 's'}? This cannot be undone.</>}
                            </p>
                            <p className={styles.deleteHelperText}>Continue to review the final confirmation.</p>
                        </>
                    ) : (
                        <p className={styles.deleteWarnText}>
                            This action cannot be undone. Delete {count} selected file{count === 1 ? '' : 's'}?
                        </p>
                    )}
                </div>
                <div className={styles.modalFooter}>
                    {step === 1 ? (
                        <button type="button" className={styles.primaryBtn} onClick={() => setStep(2)}>
                            Continue
                        </button>
                    ) : (
                        <button type="button" className={styles.primaryBtn} style={{ background: '#dc2626' }} onClick={onConfirm} disabled={loading}>
                            Delete
                        </button>
                    )}
                    <button type="button" className={styles.secondaryBtn} onClick={onClose}>
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteConfirmModal;
